module.exports = __webpack_public_path__ + "img/Path 13@3x.af2fbd02.png";